import { render, staticRenderFns } from "./corporation.vue?vue&type=template&id=ad2421e0&scoped=true&"
import script from "./corporation.vue?vue&type=script&lang=js&"
export * from "./corporation.vue?vue&type=script&lang=js&"
import style0 from "./corporation.vue?vue&type=style&index=0&id=ad2421e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2421e0",
  null
  
)

component.options.__file = "corporation.vue"
export default component.exports